import React, { useEffect, useId, useRef, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";

const StrategyBenchmarkChartOptionSelect = ({
  triggerLabel,
  ariaLabel,
  triggerContent,
  children,
  className,
  listboxClassName
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const listboxId = useId();

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const handlePointerDown = event => {
      if (wrapperRef.current?.contains(event.target)) {
        return;
      }

      setIsOpen(false);
    };

    const handleKeyDown = event => {
      if (event.key === "Escape") {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handlePointerDown, true);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("mousedown", handlePointerDown, true);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen]);

  return (
    <div
      ref={wrapperRef}
      className={classNames(
        "strategy-benchmark-chart__select relative shrink-0 self-start w-full md:w-auto",
        className
      )}
    >
      <button
        type="button"
        className="flex items-center justify-between gap-3 w-full min-h-10 px-3 py-2 border border-solid border-gray-9 rounded-lg bg-white text-black text-sm font-medium leading-100 cursor-pointer text-left"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
        aria-controls={listboxId}
        aria-label={ariaLabel || triggerLabel}
        onClick={() => setIsOpen(previous => !previous)}
      >
        {triggerContent || <span>{triggerLabel}</span>}
        <i
          className={classNames(
            "far fa-chevron-down w-4 h-4 shrink-0 transition-transform",
            isOpen && "rotate-180"
          )}
          aria-hidden="true"
        />
      </button>

      {isOpen
        ? children({
            listboxId,
            close: () => setIsOpen(false),
            listboxClassName: classNames(
              "strategy-benchmark-chart__select-listbox absolute top-full right-0 left-auto mt-1 z-20 overflow-hidden border border-solid border-gray-9 rounded-lg bg-white shadow-card-lg",
              listboxClassName
            ),
            triggerLabel
          })
        : null}
    </div>
  );
};

StrategyBenchmarkChartOptionSelect.propTypes = {
  triggerLabel: PropTypes.string.isRequired,
  ariaLabel: PropTypes.string,
  triggerContent: PropTypes.node,
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  listboxClassName: PropTypes.string
};

export default StrategyBenchmarkChartOptionSelect;
